import { Components, LinkClassKey, LinkProps } from "@mui/material";
import { MuiComponentThemeDefinition } from "../utils";

export const MuiLink: Components["MuiLink"] = {
  defaultProps: {
    underline: "none",
  },
  styleOverrides: {},
};
